import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { Language } from '@/i18n';
import { PRIVACY_POLICY, type PolicyBlock } from './content';

export function PrivacyPolicyPage() {
  const { i18n } = useTranslation();
  const lang: Language = i18n.resolvedLanguage === 'pl' ? 'pl' : 'en';
  const doc = PRIVACY_POLICY[lang];

  useEffect(() => {
    const previous = document.title;
    document.title = doc.title;
    return () => {
      document.title = previous;
    };
  }, [doc.title]);

  return (
    <div className="min-h-dvh overflow-auto bg-background">
      <div className="mx-auto max-w-3xl space-y-8 px-4 py-10 md:px-6">
        <header className="space-y-2">
          <Link to="/" className="text-sm text-muted-foreground hover:underline">
            {doc.backLabel}
          </Link>
          <h1 className="text-2xl font-semibold tracking-tight">{doc.title}</h1>
          <p className="text-xs text-muted-foreground">
            {doc.updatedLabel}: {doc.updatedValue}
          </p>
        </header>

        <div className="space-y-3">
          {doc.intro.map((block, i) => (
            <Block key={`intro-${i}`} block={block} />
          ))}
        </div>

        {doc.sections.map((section) => (
          <section key={section.heading} className="space-y-3">
            <h2 className="text-lg font-medium tracking-tight">{section.heading}</h2>
            {section.blocks.map((block, i) => (
              <Block key={i} block={block} />
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}

function Block({ block }: { block: PolicyBlock }) {
  if (block.kind === 'list') {
    return (
      <ul className="list-disc space-y-1 pl-5 text-sm leading-relaxed">
        {block.items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  }
  return <p className="text-sm leading-relaxed">{block.text}</p>;
}
